<div class="tlr-admin-container">
    
    <div class="header-bar">
        <h2>TLR Admin - Edit</h2>
    </div>
    
    <div class="edit-section">
        <div class="edit-layout">
            <div class="left-panel">
                <h3>{{ headerText }}</h3>
            </div>
            
            <div class="right-panel">
                <p-table [value]="radioOptions" styleClass="options-table">
                    <ng-template pTemplate="body" let-option>
                        <tr>
                            <td>
                                <div class="radio-option">
                                    <p-radioButton [inputId]="option.value" 
                                                  name="editOption" 
                                                  [value]="option.value" 
                                                  [(ngModel)]="selectedOption"
                                                  [disabled]="option.disabled"
                                                  (onClick)="onRadioChange(option.value)">
                                    </p-radioButton>
                                    <label [for]="option.value" [class.disabled]="option.disabled">{{ option.label }}</label>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        
        <div class="tag-number-layout">
            <div class="left-panel">
                <h3>Tag Number</h3>
            </div>
            
            <div class="right-panel tag-input-panel">
                <input type="text" [(ngModel)]="tagNumber" (keydown.enter)="onGoClick()" class="tag-number-input" numericOnly>
                <span class="field-hint">(Use numbers only, and leading zeros if necessary)</span>
                <span class="error-response">{{responseMessage}}</span>
            </div>
        </div>
        
        <div class="button-section">
            <p-button label="Go" class="primary-btn" (onClick)="onGoClick()" [loading]="isLoading"></p-button>
        </div>
    </div>
</div>
